import { archiveGroups } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

export default function ArchiveZone() {
  return (
    <section id="archive" className="mx-auto max-w-[1400px] scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <SectionHead
        kicker="BLACK DOSSIER ARCHIVE"
        title="黑料合集 · 分区档案"
        note="黑历史、塌房与负面素材分主题沉淀，持续归档"
      />
      <div className="grid gap-6 md:grid-cols-2">
        {archiveGroups.map((g) => (
          <article key={g.cat} className="group flex flex-col overflow-hidden rounded-lg border border-foreground-200/60 bg-background-50 sm:flex-row">
            <div className="relative h-52 w-full shrink-0 overflow-hidden sm:h-auto sm:w-2/5">
              <img src={g.img} alt={`${g.cat}合集`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded bg-black/55 px-2 py-1 text-[11px] font-bold text-white backdrop-blur">
                <i className="ri-folder-open-fill" /> {g.count} 篇
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-black text-foreground-950">{g.cat}</h3>
                <i className="ri-arrow-right-up-line text-foreground-400 transition-colors group-hover:text-primary-600" />
              </div>
              <p className="mt-1 text-sm text-foreground-500">{g.desc}</p>
              <ul className="mt-3 space-y-2">
                {g.items.map((it) => (
                  <li key={it}>
                    <a href="#download" className="group/item flex items-center gap-2 text-sm text-foreground-800 transition-colors hover:text-primary-600">
                      <i className="ri-file-text-line text-accent-600" />
                      <span className="line-clamp-1">{it}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}